export * from './WideScreenContainer.ui';
